/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".ms-activityItem-exampleRoot{margin-top:20px}.ms-activityItem-nameText{font-weight:bold}\n"}]);